import { useState } from 'react'
import { Film, Search, Download, Trash2 } from 'lucide-react'
import useStore from '../store/useStore'

export default function ClipLibrary() {
  const { clips } = useStore()
  const [search, setSearch] = useState('')

  const filtered = clips.filter(c =>
    c.prompt?.toLowerCase().includes(search.toLowerCase()) ||
    c.character?.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <div className="flex-1 overflow-y-auto p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-white">Clip Library</h2>
          <p className="text-slate-400 text-sm mt-1">{clips.length} video clip{clips.length !== 1 ? 's' : ''} generated</p>
        </div>
        <div className="relative">
          <Search size={15} className="absolute left-3 top-2.5 text-slate-400" />
          <input className="input pl-9 w-64" placeholder="Search clips..." value={search}
            onChange={e => setSearch(e.target.value)} />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-16">
          <Film size={48} className="text-slate-600 mx-auto mb-4" />
          <h3 className="text-white font-medium mb-2">No clips yet</h3>
          <p className="text-slate-400 text-sm">Generated video clips will appear here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-4">
          {filtered.map(clip => <ClipCard key={clip.id} clip={clip} />)}
        </div>
      )}
    </div>
  )
}

function ClipCard({ clip }) {
  return (
    <div className="card overflow-hidden group">
      <div className="aspect-video bg-surface-muted relative">
        {clip.url ? (
          <video src={clip.url} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Film size={24} className="text-slate-600" />
          </div>
        )}
        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
          <a href={clip.url} download className="p-2 rounded-lg bg-white/20 hover:bg-white/30 text-white">
            <Download size={16} />
          </a>
        </div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
          {clip.duration}s
        </div>
      </div>
      <div className="p-3">
        <p className="text-xs text-slate-300 line-clamp-2">{clip.prompt}</p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-slate-500">{clip.character || 'No character'}</span>
          <span className="text-xs text-brand-400">{clip.model}</span>
        </div>
      </div>
    </div>
  )
}
